const accountKey = 'account-info';

export const getAccountInfo = () => {
    try {
        return localStorage.getItem(accountKey);
    } catch (error) {
        console.error('Failed to get token:', error);
        return null;
    }
};

export const setAccountInfo = (data) => { 
    try {
        localStorage.setItem(accountKey, data);
    } catch (error) {
        console.error('Failed to set token:', error);
    }
};

export const removeAccountInfo = () => { 
    try {
        localStorage.removeItem(accountKey);
    } catch (error) {
        console.error('Failed to set token:', error);
    }
};